import React from 'react';
export function StatsBar() {
  return <div className="bg-brand-ink border-y border-brand-border py-6 px-6" data-id="element-282">
      <div className="max-w-[1060px] mx-auto flex flex-wrap justify-center gap-9" data-id="element-283">
        <div className="text-center" data-id="element-284">
          <span className="font-display text-[30px] font-bold text-brand-green block leading-tight" data-id="element-285">
            +2.500
          </span>
          <span className="text-xs text-brand-muted" data-id="element-286">Mujeres satisfechas</span>
        </div>
        <div className="text-center" data-id="element-287">
          <span className="font-display text-[30px] font-bold text-brand-green block leading-tight" data-id="element-288">
            6
          </span>
          <span className="text-xs text-brand-muted" data-id="element-289">Tomos completos</span>
        </div>
        <div className="text-center" data-id="element-290">
          <span className="font-display text-[30px] font-bold text-brand-green block leading-tight" data-id="element-291">
            6
          </span>
          <span className="text-xs text-brand-muted" data-id="element-292">Bonos incluidos</span>
        </div>
        <div className="text-center" data-id="element-293">
          <span className="font-display text-[30px] font-bold text-brand-green block leading-tight" data-id="element-294">
            4.9 ⭐
          </span>
          <span className="text-xs text-brand-muted" data-id="element-295">
            Calificación promedio
          </span>
        </div>
      </div>
    </div>;
}